import './SnackBar.scss';

import React from 'react';
import IconSuccess from 'assets/icons/icon-success-circle.svg';
import IconError from 'assets/icons/icon-warning-error-red.svg';

export const SNACKBAR_TYPE = {
    ERROR: 'error',
    SUCCESS: 'success',
};

export const SnackBar = ({ text, type }) => {
    const SNACKBAR_CONFIG_BY_TYPE = {
        [SNACKBAR_TYPE.SUCCESS]: { icon: IconSuccess, altType: 'success' },
        [SNACKBAR_TYPE.ERROR]: { icon: IconError, altType: 'error' },
    };

    const { icon, altType } = type && SNACKBAR_CONFIG_BY_TYPE[type];

    return (
        <div className="snackbar">
            <img className="snackbar__img" src={icon} alt={altType} />
            <p className="snackbar__text">{text}</p>
        </div>
    );
};
